module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search__info"
  }, [(_vm.resultsCount == 1) ? _c('span', [_vm._v("\n    1 note\n  ")]) : _c('span', [_vm._v("\n    " + _vm._s(_vm.resultsCount) + " notes\n  ")]), _vm._v(" "), (_vm.editing || !_vm.searching) ? _c('span', [_c('span', {
    staticClass: "command"
  }, [_vm._v("esc")]), _vm._v(" to focus search\n  ")]) : (_vm.renaming) ? _c('span', [_c('span', {
    staticClass: "command"
  }, [_vm._v("enter")]), _vm._v(" to save title\n  ")]) : (_vm.queryLength > 0) ? _c('span', [_c('span', {
    staticClass: "command"
  }, [_vm._v("ctrl")]), _vm._v(" + "), _c('span', {
    staticClass: "command"
  }, [_vm._v("enter")]), _vm._v(" to create note\n  ")]) : (_vm.selected) ? _c('span', [_c('span', {
    staticClass: "command"
  }, [_vm._v("enter")]), _vm._v(" to edit note\n  ")]) : _c('span', [_vm._v("\n    Type to search\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f05fef18!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/SearchInfo.vue
// module id = 2195
// module chunks = 0